import React, {  useState } from 'react'
import { Link,NavLink } from "react-router-dom";
import { FaUndo} from "react-icons/fa";
import Slider from 'react-slick';
 import { FaArrowLeft } from 'react-icons/fa'; // Import the back arrow icon
 import { getUserData } from '../auth';
import { useCreateReturnVendorProductsMutation } from '../apis/ReturnProductStoreApi';
import { useSelector } from 'react-redux';

     const ShopSectionDetailsAmazon = ({onBack}) => {

        const product = useSelector((state) => state.product.selectedProductStore);

     //   console.log("product log",product)
  

    const productImages = product?.images || [
        "assets/images/thumbs/product-details-thumb1.png",
        "assets/images/thumbs/product-details-thumb2.png",
        "assets/images/thumbs/product-details-thumb3.png",
        "assets/images/thumbs/product-details-thumb2.png",
    ];

      const userData = getUserData();
      const userId = userData?.uid || "";
const [createReturnProduct, { isLoading:isLoadingCreate, isSuccess }] =
useCreateReturnVendorProductsMutation();
 
    const [mainImage, setMainImage] = useState(productImages[0]);

    const settingsThumbs = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
    };
   
    const pushToStore = async () => {
        try {
            // Step 3: Call mutation to create a return product
            await createReturnProduct({ user_id: userId, Product_id: product?.id }).unwrap();
            
            console.log('createReturnProduct created successfully!');
            alert('createReturnProduct created successfully!');

            // You can refresh or update the UI here
        } catch (err) {
            if (err?.status === 409) {
                // Handle conflict (409: product already returned)
                console.error('Conflict: This product has already been returned.');
                alert('This product has already been returned. It cannot be updated.');
            } else {
                // Handle other errors
                console.error('Failed to createReturnProduct:', err);
                alert('Something went wrong while processing the return.');
            }
        }
    };
    
    return (
        <section className="product-details py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-lg-9">
                        <div className="row gy-4">
                            <div className="col-xl-6">
                                <div className="product-details__left">
                                

                                    <div className="product-details__thumb-slider border border-gray-100 rounded-16">
                                        <div className="">

                                            <div className="product-details__thumb flex-center h-100">
                                           
                                                <img src={mainImage} alt="Main Product" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-24">
                                        <div className="product-details__images-slider">
                                            <Slider {...settingsThumbs}>
                                                {productImages.map((image, index) => (
                                                    <div className="center max-w-120 max-h-120 h-100 flex-center border border-gray-100 rounded-16 p-8" key={index} onClick={() => setMainImage(image)}>
                                                        <img className='thum' src={image} alt={`Thumbnail ${index}`} />
                                                    </div>
                                                ))}
                                            </Slider>



                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="product-details__content">
                                    <h5 className="mb-12">{product?.name}</h5>
                                    <div className="flex-align flex-wrap gap-12">
                                        <div className="flex-align gap-12 flex-wrap">
                                            <div className="flex-align gap-8">
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-15 fw-medium text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                            </div>
                                            <span className="text-sm fw-medium text-neutral-600">
                                            {product?.ratings} Star Rating
                                            </span> 
                                        </div>
                                        
                                    </div>
                                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                    <p className="text-gray-700">
                                        {product?.description}
                                    </p>
                                    <div className="mt-32 flex-align flex-wrap gap-32">
                                        <div className="flex-align gap-8">
                                            <h4 className="mb-0"> 
                                          ${product?.discount}
                                            </h4>
                                            <span className="text-md text-gray-500">
                                            ${product?.price}
                                                </span>
                                        </div>  
<button
      type="submit"
      className="btn btn-main rounded-pill flex-align d-inline-flex gap-8 px-48"
      disabled={isLoadingCreate} // Disable button while either uploading or loading
      onClick={pushToStore}
    >
           <FaUndo className="me-2" /> 
           { isLoadingCreate ? 'Requesting ...' : 'Returning Product'}
    </button>

    {/* Show success message */}
    {isSuccess && <p className="text-green-500 mt-4">Product pushed successfully!</p>}

    
                                    </div>
                                    
                                    
                                     
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="product-details__sidebar border border-gray-100 rounded-16 overflow-hidden">
                            <div className="p-24">
                                                           <div className="flex-between bg-main-600 rounded-pill p-8">
                                                               <div className="flex-align gap-8">
                                                                   <span className="w-44 h-44 bg-white rounded-circle flex-center text-2xl">
                                                                       <i className="ph ph-storefront" />
                                                                   </span>
                                                                   <span className="text-white">Returned</span>
                                                               </div>
                                                               <Link
                                                                   to="/returned-product"
                                                                   className="btn btn-white rounded-pill text-uppercase"
                                                               >
                                                                  Products
                                                               </Link>
                                                           </div>
                                                       </div>
                            <div className="p-24 bg-white d-flex align-items-start gap-24 border-bottom border-gray-100">
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-truck" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Fast Delivery</h6>
                                    <p className="text-gray-700">
                                        Lightning-fast shipping, guaranteed.
                                    </p>
                                </div>
                            </div>
                            <div className="p-24 bg-white d-flex align-items-start gap-24 border-bottom border-gray-100">
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-arrow-u-up-left" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">returning product</h6>
                                    <p className="text-gray-700">Once a product is added to your store, it cannot be removed unless you request its deletion.</p>
                                </div>
                            </div>
                           
                            <div className="p-24 bg-white d-flex align-items-start gap-24 border-bottom border-gray-100">
                                <span className="w-44 h-44 bg-white text-main-600 rounded-circle flex-center text-2xl flex-shrink-0">
                                    <i className="ph-fill ph-credit-card" />
                                </span>
                                <div className="">
                                    <h6 className="text-sm mb-8">Payment</h6>
                                    <p className="text-gray-700">
                                    Please note that your customers will be able to pay in Bitcoin, Ethereum, or USDT upon receipt of goods.                                    </p>
                                </div>
                            </div> 
                            
                        </div>
                    </div>
                </div> 
                
            </div>
        </section>

    )
}

export default ShopSectionDetailsAmazon